export default function GuidelineBlock(props) {
  const type = props.type;

  return (
    <div className="w-30">
      <div className="displayFlex w-p-100 h-p-50">
        <div className="displayInlineBlock w-p-50 h-p-100 minHeightFive"></div>
        <div
          className="displayInlineBlock w-p-50 h-p-100 minHeightFive"
          style={{
            borderLeft: type !== "None" ? "1px gray dotted" : undefined,
            borderBottom:
              type === "Angle" || type === "T" ? "1px gray dotted" : undefined,
          }}
        ></div>
      </div>
      <div className="displayFlex w-p-100 h-p-50">
        <div className="displayInlineBlock w-p-50 h-p-100 minHeightFive"></div>
        <div
          className="displayInlineBlock w-p-50 h-p-100 minHeightFive"
          style={{
            borderLeft:
              type === "Straight" || type === "T"
                ? "1px gray dotted"
                : undefined,
          }}
        ></div>
      </div>
    </div>
  );
}
